import { createContext, useContext } from 'react';
import { BrandAffinityLevel } from 'modules/domains/brandAffinity';
import { NodeTrees } from 'ui/treeView';

import { Channel, List, MessageType, UserClientType } from '../domain';

export type UserMetadataQueryContextState = {
  isLoading: boolean;
  isError: boolean;
  emailAddress?: string;
  phoneNumber?: string;
  location?: string;
  clientType?: UserClientType;
  clientName?: string;
  internalUserId?: string;
  externalUserId?: string;
  brandAffinityLevel?: BrandAffinityLevel;
  allChannels?: Channel[];
  allMessageTypes?: MessageType[];
  allLists?: List[];
  dataFields?: NodeTrees;
};

export const defaultState = { isLoading: false, isError: false };

export const UserMetadataQueryContext = createContext<UserMetadataQueryContextState>(defaultState);

export const useUserMetadataQueryContext = () => useContext(UserMetadataQueryContext);
